import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { act } from "react";

export interface UserState {
  users: [any];
  schedules: [any];
}

const initialState: UserState = {
  users: <any>[],
  schedules: <any>[],
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<any>) => {
      state.users = action.payload;
    },
    setSchedules: (state, action: PayloadAction<any>) => {
      state.schedules = action.payload;
    },
  }
});

export const {
  setUsers,
  setSchedules,
} = userSlice.actions;

export default userSlice.reducer;
